import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import { Translate2 } from 'common'
import { MessageBox } from '../../../../../ui-components/util/MessageBox/MessagesBox'
import { MessageBoxType } from '../../../../../ui-components/util/Interfaces'
import styled from 'styled-components'

interface PoNumberErrorMessagesProps {
  errorMessage: string | undefined
}

export const PoNumberErrorMessageBody = observer(
  (props: PoNumberErrorMessagesProps): ReactElement => {
    return (
      <div>
        <MessageBox title="orderFailed" type={MessageBoxType.ERROR} show>
          <MessageBodyWrapper>
            <MessageBodyTextWrapper>
              {Translate2('unableToPlaceOrderError')}
            </MessageBodyTextWrapper>
            <MessageBodyTextWrapper>
              {props?.errorMessage}
            </MessageBodyTextWrapper>
          </MessageBodyWrapper>
        </MessageBox>
      </div>
    )
  }
)

const MessageBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
const MessageBodyTextWrapper = styled.div`
  padding: 16px 0px 16px 24px;
`
